import { useState } from "react";

import { Collapse, Table, TableBody, TableRow } from "@mui/material";

import AttendanceIndicator from "@app/analytics/components/AttendanceIndicator";
import { Participant } from "@app/analytics/MeetingReport/types";

import { Row } from "@rui/Stack";

import {
  Card,
  Name,
  CollapseContentWrapper,
  TableCell,
  ScoreTableCell,
  NameRow,
} from "./styles";
import TalkTimeBar from "./TalkTimeBar";

interface ParticipantCardProps {
  participant: Participant;
  meetingStartTime?: number;
  meetingEndTime?: number;
  onPlayToggle: (playing: boolean, participant: Participant) => void;
  onTurnClick: (turnIndex: number, participant: Participant) => void;
  isPlaying: boolean;
  isReelSelected: boolean;
  playable: boolean;
  expandable: boolean;
}

const ParticipantCard = ({
  participant,
  meetingStartTime,
  meetingEndTime,
  isPlaying,
  isReelSelected,
  onPlayToggle,
  onTurnClick,
  playable,
  expandable,
}: ParticipantCardProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => setIsOpen(!isOpen);

  const handlePlayToggle = (playing: boolean) => {
    onPlayToggle(playing, participant);
  };

  const handleOnTurnClick = (turnIndex: number) => {
    onTurnClick(turnIndex, participant);
  };

  return (
    <Card
      open={isOpen}
      onClick={expandable ? handleOpen : undefined}
      data-test-id="participant-card"
    >
      <Row variant="apart">
        <Row
          alignItems="center"
          spacing={1}
          flexShrink={1}
          sx={{ overflow: "hidden" }}
        >
          <AttendanceIndicator type={participant.onTime ? "onTime" : "late"} />
          <NameRow variant="left">
            <Name className="participant-name__name">{participant.name}</Name>
          </NameRow>
        </Row>
        {meetingStartTime && meetingEndTime && (
          <TalkTimeBar
            participant={participant}
            meetingStartTime={meetingStartTime}
            playing={isPlaying}
            isReelSelected={isReelSelected}
            onPlayToggle={handlePlayToggle}
            onTurnClick={handleOnTurnClick}
            meetingEndTime={meetingEndTime}
            playable={playable}
          />
        )}
      </Row>
      <Collapse in={isOpen && expandable} unmountOnExit={!expandable}>
        <CollapseContentWrapper>
          <Table data-test-id="participant-card-table">
            <TableBody>
              <TableRow>
                <ScoreTableCell score={participant.meetingScore}>
                  Participant Score
                </ScoreTableCell>
                <ScoreTableCell score={participant.charisma}>
                  Charisma
                </ScoreTableCell>
              </TableRow>
              <TableRow>
                <ScoreTableCell score={participant.sentiment}>
                  Sentiment
                </ScoreTableCell>
                <ScoreTableCell score={participant.bias}>Bias</ScoreTableCell>
              </TableRow>
              <TableRow>
                <ScoreTableCell score={participant.engagement}>
                  Engagement
                </ScoreTableCell>
                <TableCell />
              </TableRow>
            </TableBody>
          </Table>
        </CollapseContentWrapper>
      </Collapse>
    </Card>
  );
};

export default ParticipantCard;
